import { render } from "./BloccaColloForm.vue?vue&type=template&id=6c7be630&scoped=true"
import script from "./BloccaColloForm.vue?vue&type=script&lang=js"
export * from "./BloccaColloForm.vue?vue&type=script&lang=js"

import "./BloccaColloForm.vue?vue&type=style&index=0&id=6c7be630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7be630"]])

export default __exports__